import React from 'react'
import { useStartSkillsCollectionCall } from 'queries/admin/coach/useStartSkillsCollectionCall'
import {
  VoiceAgentCallContext,
  type VoiceAgentCallContextState,
} from '../../../context/VoiceAgentCallContext'
import { useVoiceCallSession } from '../../../hooks/useVoiceCallSession'

export const SkillsCollectionProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const startCallMutation = useStartSkillsCollectionCall()
  const session = useVoiceCallSession({
    startCall: ({ transport }) => startCallMutation.mutateAsync({ transport }),
  })

  const value: VoiceAgentCallContextState = {
    state: {
      title: 'Skills Collection',
      callState: session.callState,
      callId: session.callId,
      error: session.error,
      isMuted: session.isMuted,
      transcript: session.transcript,
    },
    actions: {
      startCall: session.startCall,
      endCall: session.endCall,
      reset: session.reset,
      toggleMute: session.toggleMute,
    },
  }

  return (
    <VoiceAgentCallContext.Provider value={value}>
      {children}
    </VoiceAgentCallContext.Provider>
  )
}
